import { ContentCopy as ContentCopyIcon } from "@mui/icons-material";
import { Box, Button, DialogProps } from "@mui/material";
import { DialogWrap, Input, useUserSetting } from "@sal/onevent-portal";

export interface ShareDialogProps extends Omit<DialogProps, "open"> {
	setIsOpenShareDialog: React.Dispatch<React.SetStateAction<boolean>>;
	isDialogOpen: boolean;
	reference: string;
	settingSystemName?: string;
}

export function ShareDialog({ setIsOpenShareDialog, isDialogOpen, reference, settingSystemName }: ShareDialogProps) {
	const [trackURL] = useUserSetting({
		settingSystemName: settingSystemName ?? "PublicTrackingURL",
		settingTypeSystemName: "Value"
	});

	// PublicTrackingURL stores only the base URL, so the results path is appended here.
	// Other settings (e.g. TrackingUrl) already include the full "results/?reference=" path.
	const shareURL = settingSystemName ? `${trackURL}${reference}` : `${trackURL}results/?reference=${reference}`;

	const handleOnCopy = async () => {
		if (shareURL) {
			try {
				await navigator.clipboard.writeText(shareURL);
			} catch (e) {
				if (e instanceof Error) {
					console.log("Copy to clipboard failed:", e);
				}
			}
		}
	};

	return (
		<DialogWrap
			title="Share"
			maxWidth="md"
			fullWidth
			open={isDialogOpen}
			onCloseBtnClick={() => setIsOpenShareDialog(false)}
		>
			<Box display={"flex"} gap={2}>
				<Input value={shareURL} readOnly />
				<Button variant="contained" startIcon={<ContentCopyIcon />} onClick={handleOnCopy}>
					Copy
				</Button>
			</Box>
		</DialogWrap>
	);
}
